// Charge la base commune
// Styles librairies

// Styles custom
import './scss/pages/questions'

require('./common.js')

// Scripts librairies
// import 'script-loader!waypoints/lib/jquery.waypoints.min.js'

// Pages
// var agenciesPage = require('exports-loader?agenciesPage!./js/pages/agencies.page.js')

// actions principales communes à toutes les pages
// $(document).ready(function() {
//
//
//
// })
